import * as React from "react";
import type { Stop } from "../../../types";
import { createStopTooltipOverlay } from "./stopTooltipOverlay";

type Props = {
  map: google.maps.Map | null;
  stop: Stop;
};

export default function LowZoomStopTooltip({ map, stop }: Props) {
  React.useEffect(() => {
    if (!map) return;

    const tooltip = createStopTooltipOverlay();

    tooltip.show(map, { lat: stop.lat, lng: stop.lng }, stop.name);

    return () => {
      tooltip.hide();
    };
  }, [map, stop.id, stop.lat, stop.lng, stop.name]);

  return null;
}
